import React, { useEffect, useState } from 'react'
import { RiCollapseDiagonalLine } from "react-icons/ri";
import { IoIosArrowDown, IoIosArrowUp, IoIosArrowForward } from "react-icons/io";
import { FaFilter, FaEdit, FaChalkboard, FaFileExport } from "react-icons/fa";
import { TbReload, TbArrowsSort } from "react-icons/tb";
import { MdDelete } from "react-icons/md";
import { RiAddLargeFill } from "react-icons/ri";
import AddAgent from './AddAgent';

const API_URL = `${process.env.REACT_APP_API_BASE}/auth`;

function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch {
        return {};
    }
}

function getUserIdFromTokenOrLocatorgarsotrga() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            const userId = decoded.id || decoded.userId || decoded._id;
            return { userId, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        const userId = decoded.id || decoded.userId || decoded._id;
        return { userId, token: rawToken };
    }
    return { userId: null, token: null };
}

function getTodayDateStr() {
    const now = new Date();
    now.setHours(0,0,0,0);
    return now.toISOString().split("T")[0];
}
function isSameDay(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getDate() === date2.getDate();
}

function WhatsAppContacts() {
    const { userId } = getUserIdFromTokenOrLocatorgarsotrga();
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [Editid, setEditid] = useState('');
    const [showfilter, setshowfilter] = useState(false);
    const [FilterName, setFilterName] = useState("");
    const [FilterNumber, setFilterNumber] = useState("");
    const [dateFilterType, setDateFilterType] = useState('');
    const [customDate, setCustomDate] = useState('');
    const [Name, setName] = useState("");
    const [Number, setNumber] = useState("");
    const [Email, setEmail] = useState("");
    const [NewName, setNewName] = useState("");
    const [NewNumber, setNewNumber] = useState("");
    const [Newemail, setNewemail] = useState("");
    const [currentPage, setcurrentPage] = useState(1);
    const [usersperpage, setuserperpages] = useState(10);
    const [Editcontact, setEditcontact] = useState(false);
    const [Addcontact, setAddcontact] = useState(false);

    // Fetch contacts from backend (GET /contacts/:userId per backend spec)
    useEffect(() => {
        if (!userId) {
            setContacts([]);
            return;
        }
        setLoading(true);
        fetch(`${API_URL}/contacts/${userId}`)
            .then((res) => res.json())
            .then((result) => {
                if (result && result.success && Array.isArray(result.contact)) {
                    // API returns: { success: true, contact: [...] }
                    setContacts(result.contact.map((item) => ({
                        id: item.id,
                        name: item.name ?? '',
                        phone: item.phone ?? '',
                        email: item.email ?? '',
                        country_code: item.country_code ?? '',
                        created_at: item.created_at ?? '',
                        last_message_at: '', // not in scheme; keep for UI filtering
                        last_message: '', // not in scheme; keep for UI
                        total_messages: item.total_messages ?? 0
                    })));
                } else {
                    setContacts([]);
                }
            }).catch(() => setContacts([]))
            .finally(() => setLoading(false));
    }, [userId]);

    // Handle real-time filtering UI (was used in original, keep as pattern)
    const [data, setdata] = useState([]);
    useEffect(() => {
        setdata(contacts);
    }, [contacts]);
    useEffect(() => {
        let filtered = contacts;
        if (FilterName) {
            filtered = filtered.filter(item =>
                (item.name || '').toLowerCase().includes(FilterName.toLowerCase())
            );
        }
        if (FilterNumber) {
            filtered = filtered.filter(item =>
                (item.phone || '').toLowerCase().includes(FilterNumber.toLowerCase())
            );
        }
        // Date filter (using created_at if available)
        if (dateFilterType === "today") {
            filtered = filtered.filter(item => {
                if (!item.created_at) return false;
                const date = new Date(item.created_at);
                const now = new Date();
                return isSameDay(date, now);
            });
        }
        if (dateFilterType === "yesterday") {
            filtered = filtered.filter(item => {
                if (!item.created_at) return false;
                const date = new Date(item.created_at);
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                return isSameDay(date, yesterday);
            });
        }
        if (dateFilterType === "custom" && customDate) {
            filtered = filtered.filter(item => {
                if (!item.created_at) return false;
                const date = new Date(item.created_at);
                const targetDate = new Date(customDate);
                return isSameDay(date, targetDate);
            });
        }
        setdata(filtered);
    }, [FilterName, FilterNumber, contacts, dateFilterType, customDate]);

    // Create contact (POST /contacts)
    async function addContact() {
        if (!Name || !Number) {
            alert('Please Enter Name & Number');
            return;
        }
        try {
            const res = await fetch(`${API_URL}/contacts`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    user_id: userId,
                    phone: Number,
                    name: Name,
                    email: Email || '',
                    country_code: ''
                })
            });
            const data = await res.json();
            if (data && data.success && data.contact_id) {
                // Get new contact details (simpler: just push to list, reload later)
                setContacts(prev => [
                    ...prev,
                    {
                        id: data.contact_id,
                        name: Name,
                        phone: Number,
                        email: Email || '',
                        country_code: '',
                        created_at: new Date().toISOString(),
                        last_message_at: '',
                        last_message: '',
                        total_messages: 0
                    }
                ]);
                setName('');
                setNumber('');
                setEmail('');
                setAddcontact(false);
            } else {
                alert(data.error || 'Failed to add contact');
            }
        } catch (e) {
            alert('Failed to add contact');
        }
    }

    // Update contact (PUT /contacts/:contactId)
    async function updateitem() {
        if (!Editid) return;
        try {
            const res = await fetch(`${API_URL}/contacts/${Editid}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    phone: NewNumber,
                    name: NewName,
                    email: Newemail,
                    country_code: ''
                })
            });
            const dataRes = await res.json();
            if (dataRes && dataRes.success) {
                setContacts(prev =>
                    prev.map((item) =>
                        item.id === Editid
                            ? { ...item, name: NewName, phone: NewNumber, email: Newemail }
                            : item
                    )
                );
                setEditcontact(false);
            } else {
                alert(dataRes.error || 'Failed to update');
            }
        } catch (e) {
            alert('Failed to update contact');
        }
    }

    // Delete contact (Not in backend routes from prompt. We'll just remove locally.)
    // Delete contact (DELETE /contacts/:contactId)
    async function deleteitem(id) {
        if (!id) return;
        try {
            const res = await fetch(`${API_URL}/contacts/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' }
            });
            const dataRes = await res.json();
            if (dataRes && dataRes.success) {
                setContacts(prev => prev.filter(item => item.id !== id));
            } else {
                alert(dataRes.error || 'Failed to delete contact');
            }
        } catch (e) {
            alert('Failed to delete contact');
        }
    }

    // Pagination
    const indexoflastuser = currentPage * usersperpage;
    const indexoffirstuser = indexoflastuser - usersperpage;
    const filteruser = data.slice(indexoffirstuser, indexoflastuser);
    const totalpages = Math.max(1, Math.ceil(data.length / usersperpage));

    // Export contacts as CSV
    function exportContacts() {
        const headers = ["Name", "Number", "Email", "Created At"];
        const rows = data.map(item => [
            item.name ? item.name : item.phone,
            item.phone,
            item.email,
            item.created_at ? new Date(item.created_at).toLocaleString() : ''
        ]);
        let csvContent = headers.join(",") + "\n";
        rows.forEach(row => {
            csvContent += row.map(x => `"${x ? (""+x).replace(/"/g,'""') : ""}"`).join(",") + "\n";
        });
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "whatsapp_contacts.csv");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    }

    function resetFilters() {
        setFilterName('');
        setFilterNumber('');
        setDateFilterType('');
        setCustomDate('');
    }

    return (
        <>
            <div className="dark:bg-[#121519] h-[100vh] px-4">
                <div className="border-b-[1px] border-[#cfcdcd] pb-1 ">
                    <h1 className="text-[#000] font-semibold text-[20px] dark:text-[#fff]">WhatsApp Contacts</h1>
                    <div className="text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer">
                        <span>Home</span> <IoIosArrowForward />
                        <span>WhatsApp Contacts</span>
                    </div>
                </div>
                <div className="flex flex-wrap gap-2 mt-2 mb-2">
                    <button
                        onClick={() => setAddcontact(true)}
                        className="bg-[#448c74] text-[#fff] text-[13px] font-semibold flex items-center gap-2 rounded-md p-2"
                    >
                        <RiAddLargeFill className="font-bold text-[16px]" />
                        Add Contact
                    </button>
                    <button
                        onClick={exportContacts}
                        className="bg-[#2360ad] text-[#fff] text-[13px] font-semibold flex items-center gap-2 rounded-md p-2"
                        style={{marginLeft:"8px"}}
                    >
                        <FaFileExport className="font-bold text-[16px]" />
                        Export Contacts
                    </button>
                </div>
                <div
                    onClick={() => setshowfilter(!showfilter)}
                    className="w-[100%] flex justify-between px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4"
                >
                    <div className="flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] ">
                        <RiCollapseDiagonalLine />
                        Filter Records
                    </div>
                    <div className="flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] ">
                        {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                    </div>
                </div>
                {showfilter && (
                    <div className="bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519] z-20">
                        <div className="w-[100%] flex flex-wrap gap-4">
                            <div className="w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1">
                                <label className="text-[#000] text-[12px] font-semibold dark:text-[#fff]"> Name:</label>
                                <input
                                    value={FilterName}
                                    onChange={(e) => setFilterName(e.target.value)}
                                    className="text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]"
                                    placeholder="Enter User Name"
                                    type="text"
                                />
                            </div>
                            <div className="w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1">
                                <label className="text-[#000] text-[12px] font-semibold dark:text-[#fff]">Mobile Number:</label>
                                <input
                                    value={FilterNumber}
                                    onChange={(e) => setFilterNumber(e.target.value)}
                                    className="text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]"
                                    placeholder="Enter Mobile Number"
                                    type="text"
                                />
                            </div>
                            <div className="w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1">
                                <label className="text-[#000] text-[12px] font-semibold dark:text-[#fff]">Date Filter:</label>
                                <div className="flex gap-2 mt-2 flex-wrap">
                                    <label className="flex items-center gap-1 text-[11px]">
                                        <input
                                            type="radio"
                                            name="datefilter"
                                            checked={dateFilterType==='today'}
                                            onChange={() => {setDateFilterType('today'); setCustomDate('')}}
                                        />
                                        Today
                                    </label>
                                    <label className="flex items-center gap-1 text-[11px]">
                                        <input
                                            type="radio"
                                            name="datefilter"
                                            checked={dateFilterType==='yesterday'}
                                            onChange={() => {setDateFilterType('yesterday'); setCustomDate('')}}
                                        />
                                        Yesterday
                                    </label>
                                    <label className="flex items-center gap-1 text-[11px]">
                                        <input
                                            type="radio"
                                            name="datefilter"
                                            checked={dateFilterType==='custom'}
                                            onChange={() => setDateFilterType('custom')}
                                        />
                                        Custom
                                    </label>
                                </div>
                                {dateFilterType === "custom" && (
                                    <input
                                        type="date"
                                        className="mt-2 border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]"
                                        value={customDate}
                                        onChange={e=>setCustomDate(e.target.value)}
                                        max={getTodayDateStr()}
                                    />
                                )}
                            </div>
                            <div className="w-full sm:w-[48%] lg:w-[24%] flex items-center gap-1 mt-4">
                                <button 
                                    className="flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto"
                                    type="button"
                                    tabIndex={-1}
                                    >
                                    <FaFilter /> <span className="text-[12px] font-bold">Filter</span>
                                </button>
                                <button
                                    className="flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto"
                                    onClick={resetFilters}
                                >
                                    <TbReload /> <span className="text-[12px] font-bold">Clear Filter</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                <table className="w-full overflow-hidden border-[1px] border-[#dee2e6] relative ">
                    <thead>
                        <tr className="text-left text-sm font-semibold text-gray-700">
                        <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className="text-[11px] text-[#576071] dark:text-[#fff]">Name</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className="text-[11px] text-[#576071] dark:text-[#fff]">Number</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className="text-[11px] text-[#576071] dark:text-[#fff]">Email</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className="text-[11px] text-[#576071] dark:text-[#fff]">Created At</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className="text-[11px] text-[#576071] dark:text-[#fff]">Action</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="6" className="py-2 text-center text-gray-500">Loading...</td>
                            </tr>
                        ) : filteruser.length > 0 ? (
                            filteruser.map((user) => (
                                <tr
                                    key={user.id}
                                    className="text-gray-500 odd:bg-white even:bg-[#edf1f5] dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#edf1f5]"
                                >
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">
                                        {user.name ? user.name : user.phone}
                                    </td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">
                                        {user.phone}
                                    </td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">
                                        {user.email}
                                    </td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff]">
                                        {user.created_at ? new Date(user.created_at).toLocaleDateString() : "-"}
                                    </td>
                                    <td className="p-1 text-[11px] flex gap-1 items-center border-[1px] border-[#dee2e6] dark:text-[#fff]">
                                        <button
                                            onClick={() => {
                                                setEditid(user.id);
                                                setEditcontact(true);
                                                setNewName(user.name || '');
                                                setNewNumber(user.phone || '');
                                                setNewemail(user.email || '');
                                            }}
                                            className="p-1 border-[1px] border-[#3f7fca] rounded-md text-[#3f7fca] hover:text-[#fff] hover:bg-[#3f7fca]"
                                        >
                                            <FaEdit />
                                        </button>
                                        <button
                                            onClick={() => deleteitem(user.id)}
                                            className="p-1 border-[1px] border-[#ed5050] rounded-md text-[#ed5050] hover:text-[#fff] hover:bg-[#ed5050]"
                                        >
                                            <MdDelete />
                                        </button>
                                        <button
                                            className="p-1 border-[1px] border-[#121519] rounded-md text-[#121519] hover:text-[#fff] hover:bg-[#121519]"
                                        >
                                            <FaChalkboard />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                                <td colSpan="6" className="p-1 text-[11px]">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <div className="flex justify-between w-[100%] ">
                    <p className="text-[11px] text-[#3f7fc8] mt-2">
                        Showing {indexoffirstuser + 1} to {Math.min(indexoflastuser, data.length)} of {data.length} records
                    </p>
                    <div className="flex justify-center mt-4 space-x-3 relative z-0">
                        <button
                            disabled={currentPage === 1}
                            onClick={() => setcurrentPage((prev) => prev - 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
                        >
                            Prev
                        </button>
                        <p className="text-[11px] text-[#3f7fc8] mt-2">
                            {currentPage} page of {totalpages} pages
                        </p>
                        <button
                            disabled={currentPage === totalpages}
                            onClick={() => setcurrentPage((prev) => prev + 1)}
                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>

            {/* Edit Contact Modal */}
            <AddAgent isOpen={Editcontact} onClose={() => setEditcontact(false)} heading={"Add/Edit WhatsApp Contact"}>
                <div className="py-1 px-4 w-[100%] dark:bg-[#121519]">
                    <div className="w-[100%] flex flex-wrap gap-2">
                        <div className="w-full flex flex-col gap-1">
                            <label className="text-[#000] text-[12px] font-semibold dark:text-[#fff]">Name</label>
                            <input
                                name="Name"
                                value={NewName}
                                onChange={(e) => setNewName(e.target.value)}
                                placeholder="Enter User name"
                                className="text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]"
                                type="text"
                            />
                        </div>
                        <div className="w-full flex flex-col gap-1">
                            <label className="text-[#000] text-[12px] font-semibold dark:text-[#fff]">Number</label>
                            <input
                                name="NewNumber"
                                value={NewNumber}
                                onChange={(e) => setNewNumber(e.target.value)}
                                placeholder="Enter User Number"
                                className="text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]"
                                type="text"
                            />
                        </div>
                        <div className="w-full flex flex-col gap-1">
                            <label className="text-[#000] text-[12px] font-semibold dark:text-[#fff]">Email</label>
                            <input
                                name="Newemail"
                                value={Newemail}
                                onChange={(e) => setNewemail(e.target.value)}
                                placeholder="Enter Email"
                                className="text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]"
                                type="text"
                            />
                        </div>
                        <div className="w-full flex items-center justify-end gap-1 mt-4">
                            <button
                                onClick={updateitem}
                                className="flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 gap-2 bg-[#37715d] text-[#fff] w-full sm:w-auto"
                            >
                                <span className="text-[12px] font-bold">Save</span>
                            </button>
                            <button
                                onClick={() => setEditcontact(false)}
                                className="flex items-center justify-end border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto"
                            >
                                <span className="text-[12px] font-bold">Close</span>
                            </button>
                        </div>
                    </div>
                </div>
            </AddAgent>
            {/* Add Contact Modal */}
            <AddAgent isOpen={Addcontact} onClose={() => setAddcontact(false)} heading={"Add/Edit WhatsApp Contact"}>
                <div className="py-1 px-4 w-[100%] dark:bg-[#121519]">
                    <div className="w-[100%] flex flex-wrap gap-2">
                        <div className="w-full flex flex-col gap-1">
                            <label className="text-[#000] text-[12px] font-semibold dark:text-[#fff]">Name</label>
                            <input
                                name="Name"
                                value={Name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Enter User name"
                                className="text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]"
                                type="text"
                            />
                        </div>
                        <div className="w-full flex flex-col gap-1">
                            <label className="text-[#000] text-[12px] font-semibold dark:text-[#fff]">Number</label>
                            <input
                                name="Number"
                                value={Number}
                                onChange={(e) => setNumber(e.target.value)}
                                placeholder="Enter User Number"
                                className="text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]"
                                type="text"
                            />
                        </div>
                        <div className="w-full flex flex-col gap-1">
                            <label className="text-[#000] text-[12px] font-semibold dark:text-[#fff]">Email</label>
                            <input
                                name="Email"
                                value={Email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter Email"
                                className="text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]"
                                type="text"
                            />
                        </div>
                        <div className="w-full flex items-center justify-end gap-1 mt-4">
                            <button
                                onClick={addContact}
                                className="flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 gap-2 bg-[#37715d] text-[#fff] w-full sm:w-auto"
                            >
                                <span className="text-[12px] font-bold">Save</span>
                            </button>
                            <button
                                onClick={() => setAddcontact(false)}
                                className="flex items-center justify-end border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto"
                            >
                                <span className="text-[12px] font-bold">Close</span>
                            </button>
                        </div>
                    </div>
                </div>
            </AddAgent>
        </>
    );
}

export default WhatsAppContacts;
